import React, { Component } from 'react';
import { getStateAwareUrl } from 'utils/utils.js';
import ModalImage from "./react-modal-image/src/index.js";


class FortyXImage extends Component {

    constructor(props) {
        super(props);
        this.imageRef = React.createRef();
        this.init = true;
    }

    render() {
        return <div className="forty-x-image" style={{
            filter: `brightness(${this.props.brightness * 2}%) contrast(${this.props.contrast * 2}%)`
            }}>
            <ModalImage
                small={getStateAwareUrl('/dev-ssd/last_preview/last_preview_40x_image/image.jpg?time=' + Date.now())}
                large={getStateAwareUrl('/dev-ssd/last_preview/last_preview_40x_image/image.jpg?time=' + Date.now())}
                alt="Image!"
                hideDownload
                move = {this.props.position}
                updateMove = {this.props.updateImageCoordinates}
            />
        </div>;
    }
}

export default FortyXImage;
